import React from 'react'
import Login from '@modules/auth/Login/Login'
import { AuthPageLayout } from '@elements'

const LoginPage = () => {
  return <Login />
}

LoginPage.getLayout = ({ router, page }) => {
  return <AuthPageLayout page={page} />
}

export default LoginPage
